module.exports = __webpack_public_path__ + "img/logo.89f41ae6.png";